import * as React from "react";
import "./textDropDownWrapper.scss";
import IconSmall from "../../atoms/Icon/IconSmall";
import {Icon} from "../../atoms/Icon/Icon";
import * as classNames from "classnames";
import ButtonTertiary from "../../atoms/Buttons/ButtonTertiary";

interface IProps {
	/**
	 * Text to display.
	 */
	text: string;
	/**
	 * On click callback.
	 * @param {React.MouseEvent<HTMLDivElement>} evt
	 */
	onClick?: (evt: React.MouseEvent<HTMLDivElement>) => void;
	/**
	 * Flag for disable action.
	 */
	disabled?: boolean;
	/**
	 * On delete icon click callback.
	 * @param {React.MouseEvent<HTMLSpanElement>} evt
	 */
	onRemoveClick?: (evt: React.MouseEvent<HTMLSpanElement>) => void;
	/**
	 * Indicate if selection is removable.
	 */
	removable?: boolean;
	/**
	 * Show all items link action
	 */
	onShowAllItems?: () => any
}

export default class TextDropDownWrapper extends React.Component<IProps, {}> {
	constructor(props: IProps) {
		super(props);
		this.onDeleteIconClick = this.onDeleteIconClick.bind(this);
	}

	render() {
		const classFromProps = classNames({
			"m-text-dropdown-wrapper-module": true,
			"m-text-dropdown-wrapper-module_disabled": this.props.disabled
		});
		return (
			<div className={classFromProps}>
				<div className="m-text-dropdown-wrapper-module_content"
					 onClick={(evt) => !this.props.disabled && this.props.onClick(evt)}>
					{this.props.removable &&
					<span className="m-text-dropdown-wrapper-module_icon-left" onClick={this.onDeleteIconClick}>
						<IconSmall icon={Icon.X} variant={"scarlet"}/>
					</span>
					}
					{this.props.text}
					<span className="m-text-dropdown-wrapper-module_icon-right">
						<IconSmall icon={Icon.ArrowDown} variant={"lighterBlue"}/>
					</span>
					{this.props.onShowAllItems &&
					<ButtonTertiary label={"Show all"} onClick={this.props.onShowAllItems}/>
					}
				</div>
				{this.props.children}
			</div>
		);
	}

	onDeleteIconClick(evt: React.MouseEvent<HTMLSpanElement>) {
		if (this.props.onRemoveClick) {
			evt.stopPropagation();
			this.props.onRemoveClick(evt);
		}
	}
}
